import { dataFullCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFullCircleSolid = /*#__PURE__*/createIcon(dataFullCircleSolid)
export default IconFullCircleSolid
